/* jshint esversion: 6 */
import RouteView from "@/views/common/views/RouteView";
// import { device } from "@/utils";
/**
 * 自动引入当前文件夹下所有module
 * require.context(directory, useSubdirectories = false, regExp = /^.//);
 * @param {String} directory 读取文件的路径
 * @param {Boolean} directory 匹配文件的正则表达式
 * @param {regExp} regExp 读取文件的路径
 */
const routerFiles = require.context('./routers', true, /.js$/)
const routerMaps = routerFiles.keys().reduce((modules, modulePath) => {
  // const moduleName = modulePath.replace(/^.\/(.*)\.js/,'$1');
  const value = routerFiles(modulePath);
  return modules.concat(value.default)
}, [])
// 将需要动态注册的路由提取到vuex中
export const asyncRouterMap = [
  {
    path: "/dashboard",
    name: "dashboard",
    sort: 1,
    component: () => import("@/views/pc/dashboard"),
    meta: { title: "工作台", keepAlive: true, icon: "md-desktop" },
  },
  {
    path: "/account/center",
    name: "center",
    title: "个人中心",
    sort: 2,
    meta: { title: "个人中心" },
    hidden: true,
    component: () => import("@/views/pages/UserCenter"),
    meta: { title: "个人中心", keepAlive: false },
  },
  {
    path: "/account/password",
    name: "editPassword",
    title: "个人中心",
    sort: 2,
    meta: { title: "个人中心" },
    hidden: true,
    component: () => import("@/views/pages/password"),
    meta: { title: "修改密码", keepAlive: false },
  },

  ...routerMaps,
  // setting
  {
    path: "/setting",
    name: "setting",
    sort: 9,
    redirect: "/setting/department",
    component: RouteView,
    meta: { title: "系统管理", icon: "md-settings" },
    children: [
      {
        path: "/setting/department",
        component: () => import("@/views/pc/setting/department"),
        name: "Department",
        sort: 1,
        hideChildrenInMenu: true,
        meta: {
          title: "部门团队",
          hiddenHeaderTitle: true,
          icon: "ios-people",
        },
        children: [
          {
            path: "/setting/department/user-list/:id",
            name: "DepartmentUserList",
            hidden: true,
            component: () => import("@/views/pc/setting/department/userList"),
            meta: {
              title: "组织下用户列表",
            },
          },
          {
            name: "sys_department_list",
            meta: {
              title: "查看机构",
              perms: "sys:department:tree,sys:department:one",
            },
          },
          {
            name: "sys_department_add",
            meta: {
              title: "新增机构",
              perms: "sys:department:save,sys:role:select",
            },
          },
          {
            name: "sys_department_update",
            meta: {
              title: "修改机构",
              perms: "sys:department:update,sys:role:select",
            },
          },
          {
            name: "sys_department_disable",
            meta: {
              title: "禁用机构",
              perms: "sys:department:disable",
            },
          },
          {
            name: "sys_department_enable",
            meta: {
              title: "启用机构",
              perms: "sys:department:enable",
            },
          },
          {
            name: "sys_department_synchronous",
            meta: {
              title: "同步到微信",
              perms: "sys:department:synchronous",
            },
          },
          
        ],
      },
      {
        path: "/user",
        name: "InforMationUser",
        sort: 2,
        component: () => import("@/views/pc/setting/user"),
        hideChildrenInMenu: true,
        meta: {
          title: "人员管理",
          hiddenHeaderTitle: true,
          icon: "ios-person",
        },
        children: [
          {
            name: "info_user_list",
            meta: {
              title: "人员列表",
              perms: "sys:user:list,sys:user:info",
            },
          },
          {
            name: "info_user_show",
            meta: {
              title: "查看人员详情",
              perms: "sys:user:show",
            },
          },
          {
            name: "info_user_add",
            meta: {
              title: "新增人员信息",
              perms: "sys:user:save,sys:role:add",
            },
          },
          {
            name: "info_user_update",
            meta: {
              title: "修改人员信息",
              perms: "sys:user:update,sys:role:select",
            },
          },
          {
            name: "info_user_disable",
            meta: {
              title: "禁用人员",
              perms: "sys:user:disable",
            },
          },
          {
            name: "info_user_enable",
            meta: {
              title: "启用人员",
              perms: "sys:user:enable",
            },
          },
          {
            name: "info_user_delete",
            meta: {
              title: "删除人员信息",
              perms: "sys:user:delete",
            },
          },
          {
            name: "info_user_clockin",
            meta: {
              title: "人员考勤信息",
              perms: "sys:user:clockin",
            },
          },
        ],
      },
      {
        path: "/information/auth",
        component: () => import("@/views/pc/setting/auth"),
        name: "Auth",
        sort: 3,
        hideChildrenInMenu: true,
        meta: {
          title: "岗位管理",
          hiddenHeaderTitle: true,
          icon: "md-briefcase",
        },
        children: [
          {
            name: "sys_auth_list",
            meta: {
              title: "查看岗位",
              perms: "sys:role:list,sys:role:info",
            },
          },
          {
            name: "sys_auth_add",
            meta: {
              title: "新增岗位",
              perms: "sys:role:save,sys:role:list",
            },
          },
          {
            name: "sys_auth_update",
            meta: {
              title: "修改岗位",
              perms: "sys:role:update,sys:role:list",
            },
          },
          {
            name: "sys_auth_delete",
            meta: {
              title: "删除岗位",
              perms: "sys:role:delete",
            },
          },
          {
            name: "sys_auth_menu",
            meta: {
              title: "岗位菜单配置",
              perms: "sys:role:menu",
            },
          },
        ],
      },
      {
        path: "/setting/menu",
        name: "Menu",
        sort: 4,
        component: () => import("@/views/pc/setting/menu"),
        meta: {
          title: "菜单管理",
          hiddenHeaderTitle: true,
          icon: "md-menu",
        },
        children: [
          {
            name: "sys_menu_list",
            meta: {
              title: "查询菜单",
              perms: "sys:menu:list",
            },
          },
          {
            name: "sys_menu_update",
            meta: {
              title: "修改菜单",
              perms: "sys:menu:update",
            },
          },
          {
            name: "sys_menu_sync",
            meta: {
              title: "同步菜单",
              perms: "sys:menu:sync",
            },
          },
        ],
      },
      {
        path: "/setting/unit",
        name: "Unit",
        sort: 5,
        component: () => import("@/views/pc/setting/unit"),
        hideChildrenInMenu: true,
        meta: {
          title: "组织机构",
          hiddenHeaderTitle: true,
          icon: "md-pie",
        },
        children: [
          {
            name: "info_unit_add",
            meta: {
              title: "新增组织机构",
              perms: "sys:unit:save,sys:unit:one",
            },
          },
          {
            name: "info_unit_update",
            meta: {
              title: "修改组织机构",
              perms: "sys:unit:update,sys:unit:one",
            },
          },
          {
            name: "info_unit_disable",
            meta: {
              title: "禁用/启用组织机构",
              perms: "sys:unit:disable",
            },
          },
        ],
      },
      {
        path: "/setting/document",
        name: "Document",
        sort: 6,
        component: () => import("@/views/pc/setting/document"),
        hideChildrenInMenu: true,
        meta: {
          title: "文件管理",
          hiddenHeaderTitle: true,
          icon: "md-document",
        },
        children: [
          {
            name: "info_document_list",
            meta: {
              title: "查看文件管理",
              perms: "sys:document:list,sys:document:info",
            },
          },
          {
            name: "info_document_add",
            meta: {
              title: "新增文件管理",
              perms: "sys:document:save,sys:document:select",
            },
          },
          {
            name: "info_document_update",
            meta: {
              title: "修改文件管理",
              perms: "sys:document:update,sys:document:select",
            },
          },
          {
            name: "info_document_delete",
            meta: {
              title: "删除文件管理",
              perms: "sys:document:delete",
            },
          },
        ],
      },
      {
        path: "/setting/dict",
        name: "Dict",
        sort: 7,
        component: () => import("@/views/pc/setting/dict"),
        hideChildrenInMenu: true,
        meta: {
          title: "字典维护",
          keepAlive: false,
          hiddenHeaderTitle: true,
          icon: "ios-book",
        },
        children: [
          {
            path: "/setting/dict/:id",
            component: () => import("@/views/pc/setting/dict/children"),
            name: "SubDict",
            hidden: true,
            meta: {
              title: "子字典",
              keepAlive: false,
              perms: "dictionary:list",
            },
          },
          {
            name: "info_dictionary_modify",
            meta: {
              title: "字典新增或修改",
              perms: "sys:dictionary:modify",
            },
          },
          {
            name: "info_dictionary_disable",
            meta: {
              title: "字典禁用",
              perms: "sys:dictionary:disable",
            },
          },
          {
            name: "info_dictionary_enable",
            meta: {
              title: "字典启用",
              perms: "sys:dictionary:enable",
            },
          },
        ],
      },
      {
        path: '/setting/log',
        component: () => import("@/views/pc/setting/log"),
        name: 'Log',
        meta: {
          title: '日志查询',
          hiddenHeaderTitle: true,
          icon: "ios-book",
          perms: 'sys:log:list'
        }
      }
    ],
  },
];

/**
 * 基础路由 存放无需权限控制的路径 以及 独立页面 组件
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: "/index",
    name: "index",
    redirect: "/dashboard", // “/”路径 直接跳转到 “/index”
    meta: { title: "首页" },
  },
  {
    path: "/message/:type", // msg 消息通知 1 通知 todo 待办 2 通知
    redirect: to => {
      // 方法接收目标路由作为参数
      // return 重定向的字符串路径/路径对象
      console.log('to', to)
      return { path: '/dashboard', query: {...to.params, ...to.query}}
    },
    name: 'MSG',
    meta: {
      title: '信息中心',
    }
  },
  {
    path: "/login",
    name: "login",
    title: "登录",
    meta: { title: "登录" },
    component: () => import("@/views/pages/login"),
  },
  {
    path: "/logout",
    name: "logout",
    title: "登出",
    meta: { title: "登出" },
    component: () => import("@/views/pages/login"),
  },
  {
    path: "/404",
    name: "404",
    title: "404-页面不存在",
    meta: { title: "404-页面不存在" },
    component: () => import("@/views/pages/error"),
  },
];
